// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__nezXm","layoutBodyContainer":"Layout_layoutBodyContainer__porXo","childrenEle":"Layout_childrenEle__c7Gik"};